import React from 'react';
import AuditTrailView from './auditTrail/AuditTrailView';

/** Project-scoped audit trail tab. */
export default function ProjectAuditTrail({ selectedProject }) {
  const projectId = selectedProject?.id ?? selectedProject?.projectId;
  const projectName = selectedProject?.projectName || selectedProject?.name || null;

  return (
    <AuditTrailView
      projectId={projectId}
      projectName={projectName}
      description={`Project activity log${projectName ? ` for ${projectName}` : ''}. Filter by module, event, actor, or date range.`}
    />
  );
}
